var map = {
	"./Doge Raid Seal.png": 5704,
	"./Dungeon Reset.png": 101,
	"./Pickaxe.png": 8443,
	"./Sickle.png": 1923,
	"./adventure_potion.png": 6662,
	"./axe.png": 86,
	"./bg.png": 1077,
	"./big_health_potion.png": 3129,
	"./bow.png": 2326,
	"./box.png": 1105,
	"./button.png": 6564,
	"./cloth.png": 5286,
	"./common_lootbox.png": 9915,
	"./cotton.png": 7153,
	"./cotton_shirt.png": 9852,
	"./cotton_trousers.png": 6441,
	"./fiber.png": 3668,
	"./full_health_potion.png": 5878,
	"./golden_sword.png": 4193,
	"./iron_bar.png": 8364,
	"./iron_ore.png": 467,
	"./knife.png": 1033,
	"./leather.png": 3141,
	"./leather_hood.png": 8684,
	"./leather_pants.png": 4118,
	"./leather_tunic.png": 8917,
	"./legendary_lootbox.png": 8645,
	"./linen_cowl.png": 2448,
	"./linen_pants.png": 8737,
	"./linen_robe.png": 1813,
	"./linen_sandals.png": 9959,
	"./lootbox_key.png": 9507,
	"./meat.png": 8945,
	"./medium_health_potion.png": 9644,
	"./pepe.png": 2224,
	"./placeholder.png": 8745,
	"./rare_lootbox.png": 7772,
	"./sandals.png": 8354,
	"./seal.png": 4375,
	"./shoes.png": 1774,
	"./small_health_potion.png": 838,
	"./steel.png": 2763,
	"./steel_armor.png": 5743,
	"./steel_boots.png": 6685,
	"./steel_helmet.png": 875,
	"./steel_pants.png": 4440,
	"./stone.png": 3945,
	"./sword.png": 341,
	"./wood.png": 8031,
	"./wooden_plank.png": 9187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2195;